import { useLocation, useNavigate } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/8ae829f1f3ae863ba0771f16530de4a8/83c892b906c51bf7ea2e0c2eee7aa7ce.png"
                alt="R3D Nuisibles Logo"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Votre partenaire de confiance pour la lutte contre les nuisibles. Solutions professionnelles et respectueuses de l'environnement.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-brand-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-brand-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-brand-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-brand-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base font-bold mb-6">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('accueil')} className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  Accueil
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('valeurs')} className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  Valeurs
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('references')} className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  Références
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('temoignages')} className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  Témoignages
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleNavigation('/deratisation')}
                  className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer"
                >
                  Dératisation
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/desinsectisation')}
                  className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer"
                >
                  Désinsectisation
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/desinfection')}
                  className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer"
                >
                  Désinfection
                </button>
              </li>
              <li className="text-sm text-gray-400">Protection Préventive</li>
              <li className="text-sm text-gray-400">Solutions Professionnelles</li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-brand-400 text-lg flex-shrink-0 mt-0.5"></i>
                <a href="tel:+33619794845" className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  06 19 79 48 45
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-brand-400 text-lg flex-shrink-0 mt-0.5"></i>
                <a href="mailto:r3dnuisibles@gmail.com" className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                  r3dnuisibles@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-brand-400 text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-sm text-gray-400">
                  1308 chemin de la Rourède<br />
                  83550 Vidauban, France
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2025 R3DNUISIBLES. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                Mentions Légales
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                Politique de Confidentialité
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-brand-400 transition-colors cursor-pointer">
                CGV
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}